import { render, staticRenderFns } from "./Layer2Billing.vue?vue&type=template&id=44e4fae5&"
import script from "./Layer2Billing.vue?vue&type=script&lang=js&"
export * from "./Layer2Billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports